module.exports = __webpack_public_path__ + "static/media/ehealth_dental_banner_mobile.a937c012.jpg";